export default "__VITE_ASSET__1ac1cf14__"